import { IGetApplyNewBetDateRequest, TGetApplyNewBetDateModel } from './types';

export function createGetApplyNewBetDateModel(parameters: IGetApplyNewBetDateRequest): TGetApplyNewBetDateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'auction',
    pathApi: '/v1/get-apply-new-bet-date-by-announcement/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}
